import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { Modal, Button } from 'react-bootstrap'
import React from 'react'
import './style.scss'

export interface DialogButtonProps<T = any> {
  variant: 'primary' | 'secondary' | 'warning' | 'danger' | 'success' | 'info' | 'light' | 'dark' | 'link';
  text: string;
  resolveType: ModalResolveType;
  value: T;
}

export interface DialogProps {
  title?: string;
  message: string | React.ReactNode;
  buttons: DialogButtonProps[];
}

function DialogWrapper({ title, message, buttons }: DialogProps) {
  const { resolve, hide, remove } = useModalAction()
  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }
  return (
    <Modal show onHide={handleClose} centered>
      {
        title && <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      }
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        {buttons.map((button) => (
          <Button
            key={`${button.text}-${JSON.stringify(button.value)}`}
            variant={button.variant}
            onClick={() => {
              resolve(button.resolveType, button.value);
              hide();
              remove();
            }}
          >
            {button.text}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  );
}

export const Dialog = createModal(DialogWrapper)
